import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { pipelineStageActionLabels } from '../FundOpportunityAdmin/pipelineStageActionLabels';
import ContactFundOpportunityPipelineRow from './ContactFundOpportunityPipelineRow';
import { FundOpportunityWithInvestor } from './contactFundOpportunityKanbanTypes';

interface ContactFundOpportunityKanbanStageColumnProps {
  title: string;
  stage: string;
  loaded: boolean;
  opportunities: FundOpportunityWithInvestor[];
  showPromote?: boolean;
  showDemote?: boolean;
  showDelete?: boolean;
  onPromote: (opportunity: FundOpportunityWithInvestor) => void;
  onDemote: (opportunity: FundOpportunityWithInvestor) => void;
  onDelete: (opportunity: FundOpportunityWithInvestor) => void;
}

export function ContactFundOpportunityKanbanStageColumn({
  title,
  stage,
  loaded,
  opportunities,
  showPromote,
  showDemote,
  showDelete,
  onPromote,
  onDemote,
  onDelete,
}: ContactFundOpportunityKanbanStageColumnProps) {
  const labels = pipelineStageActionLabels(stage);

  return (
    <Box className="pipeline-column" sx={{ minWidth: '12.5rem', mr: 2 }}>
      <Box className="stage-header" sx={{ mb: 1 }}>
        <Typography className="stage-title" variant="subtitle2" sx={{ fontWeight: 'bold' }}>
          {title} ({opportunities.length})
        </Typography>
      </Box>

      <Box
        className="stage-content"
        sx={{
          minHeight: 120,
          p: 0.5,
          backgroundColor: 'rgba(255,255,255,0.1)',
          borderRadius: '4px',
        }}
      >
        {!loaded ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress size={20} />
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            {opportunities.map((opportunity) => (
              <ContactFundOpportunityPipelineRow
                key={opportunity.id}
                opportunity={opportunity}
                labels={labels}
                onPromote={showPromote ? () => onPromote(opportunity) : undefined}
                onDemote={showDemote ? () => onDemote(opportunity) : undefined}
                onDelete={showDelete ? () => onDelete(opportunity) : undefined}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}
